
import $ from 'cash-dom';
import axios from 'axios';
import Mustache from 'mustache'

import flatpickr from 'flatpickr';

import dayjs from 'dayjs'
import 'dayjs/locale/nl';
dayjs.locale('nl');

var customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);

var duration = require('dayjs/plugin/duration');
dayjs.extend(duration);



(function ($) {

  let recalculation_running = false,
    wants_recalculation = false;

  let receipt_line = `<li><p><span> {{key}}: </span> {{ value}} </p></li>`,
    info_line = `<li><p class="{{type}}"> {{info}} </p></li>`,
    component_block = `<li class="receipt__costs"><span> {{component_title}}</span> {{component_costs}}</li>`,
    component_line = `<p>{{name}} <span>{{if amount}}&euro; {{amount}}{{else}}inclusief{{/if}}</span></p>`,
    total_line = `<p> Totaal <span> &euro; {{amount}} </span> </p>`,
    error_message = `<span class="input-error agegroup-error">{{msg}}</span>`;

  const receipt_meta = `<ul class="receipt__meta">
        <li data-icon="a">
            <p class="meta--age"><span>Leeftijdsgroep</span>{{audience}}</p>
        </li>
        <li data-icon="U">
            <p class="meta--date"><span>Periode</span>{{departure}} - {{return}} ({{duration}} dagen)</p>
        </li>
        <li data-icon="{{transport_icon}}">
            <p class="meta--transport"><span>Vervoer</span>{{transport}}</p>
        </li>
        </ul>`;

  const receipt_component = `<li>
            <h3 class="accordion-title" data-icon="r" aria-expanded="false" aria-controls="accordion__{{identifier}}">
                {{component_title}} {{#component_costs}}<span>&euro; {{component_costs}}</span>{{/component_costs}}
            </h3>
            <div class="accordion-inner" id="accordion__{{identifier}}">
                <ul class="receipt-list">
                    {{#components_list}}
                    <li>
                        <h4 class="receipt-list__title">{{name}}</h4>
                        <p>{{description}} <span>{{#amount}}&euro; {{amount}}{{/amount}}{{^amount}}inclusief{{/amount}}</span></p>
                    </li>
                    {{/components_list}}
                </ul>
            </div>
        </li>`;

  let receipt_total = `<div class="receipt__price">
            <span>Totaal</span>
            <span>&euro; {{total_amount}}</span>
        </div>`;

  function recalculate_and_build_bon() {
    // console.info('recalculating');

    if (!recalculation_running) {
      recalculation_running = true;

      let app_request_type = request_type || false;

      if (app_request_type == 'option') {
        receipt_total = `<div class="receipt__price">
                  <span>Vanaf</span>
                  <span>&euro; {{total_amount}}</span>
              </div>`;
      }

      if ($('#mandatory_costs')) {
        $('#mandatory_costs').remove();
      }

      $('div.alert-box.availability').hide();

      $('#mobile-total-price').html('Berekenen...');

      // $('div.receipt-jsrender-components-container').html(Mustache.render(info_line, {type: 'info', info: 'Bezig met laden...'}));

      // $('#receipt_total').hide();

      // explicitly set audience based on departure
      let audience = new String($('input[name="departure"]:checked').data('audience'));
      $('input[type="hidden"][name="audience"]').val(audience);

      $('div.receipt-jsrender-tripinfo-container').html('');
      $('div.receipt-jsrender-components-container').html('<p>Bezig met berekenen, een ogenblik geduld.</p>');
      $('div.receipt-jsrender-total-container').html('');

      axios.post('/boeken/calculate', $('input[type="hidden"], .recalculate, .postdata').serialize())
        .catch((error) => {
          console.error(error);
        })
        .then((xmlHttpResponse) => {
          var content = '<ul>';
          // content += Mustache.render(receipt_line, {key:'Bestemming', value: xmlHttpResponse.data.trip.name});
          // content += Mustache.render(receipt_line, {key:'Verblijf', value: xmlHttpResponse.data.trip.acco});

          $('span.receipt-boardtype-container').html(', op basis van ' + xmlHttpResponse.data.trip.boardtype);

          // show warning when on request or not available

          if (app_request_type && app_request_type == 'option') {
            console.info('option?!?');

            const submit_button = $('input[type="submit"].btn-checkout');

            if (xmlHttpResponse.data.availability.toUpperCase().match(/(NA|RQ)+/) ||
              ('is_optionbooking_available' in xmlHttpResponse.data && !xmlHttpResponse.data.is_optionbooking_available)) {

              console.info('disable submit remove class btn--primary');
              if (xmlHttpResponse.data.availability.toUpperCase().match(/RQ/)) {
                $('div.alert-box.availability > .alert-box-title').html('Het is niet mogelijk om een optie op deze reis te nemen.');
                $('div.alert-box.availability > .alert-box-content').html('Deze reis is op aanvraag en daarom is het helaas niet meer mogelijk om een optie te nemen. Je kunt wel een definitieve boeking maken.');
              }
              else if (xmlHttpResponse.data.availability.toUpperCase().match(/NA/)) {
                $('div.alert-box.availability > .alert-box-title').html('De reis zit vol.');
                $('div.alert-box.availability > .alert-box-content').html('Deze reis is niet beschikbaar en is het helaas ook niet mogelijk om een optie te nemen.');
              }
              else if ('is_optionbooking_available' in xmlHttpResponse.data && !xmlHttpResponse.data.is_optionbooking_available) {
                $('div.alert-box.availability > .alert-box-title').html('Het is niet mogelijk om een optie op deze reis te nemen.');
                $('div.alert-box.availability > .alert-box-content').html('Deze reis is niet meer beschikbaar om een optie op te nemen.');
              }

              $('div.alert-box.availability').show();

              content += Mustache.render(info_line, { type: 'warning', info: 'Het is niet mogelijk om een optie op deze reis te nemen.' });
              content += '</ul>';

              $('div.receipt-jsrender-components-container').html(content);
              submit_button.attr('disabled', 'disabled').removeClass('btn--primary').addClass('status--na');
              $('#warn-na').html('<p class="booking-errors">Het is niet mogelijk om een optie op deze reis te nemen.</p>').show();

              $('#trip-receipt-container').find('div.block__footer').hide();

              return;
            }
            else if (submit_button && !submit_button.hasClass('btn--primary')) {
              console.info('enable submit with class btn--primary');
              submit_button.removeAttr('disabled').addClass('btn--primary');
              $('#warn-na').hide().html('');
              $('#trip-receipt-container').find('div.block__footer').show();
            }
          } // end if app_request_type == 'option'
          else {

            if (xmlHttpResponse.data.availability.toUpperCase().match(/NA/)) {
              console.info('trip not available');

              $('div.alert-box.availability > .alert-box-title').html('De reis zit vol.');
              $('div.alert-box.availability > .alert-box-content').html('Helaas is deze reis niet meer te boeken.');
              $('div.alert-box.availability').show();

              content += Mustache.render(info_line, {
                type: 'warning',
                info: 'Je selectie is niet meer beschikbaar.'
              });
              content += '</ul>';

              $('div.receipt-jsrender-components-container').html(content);
              $('input[type="submit"]').attr('disabled', 'disabled').removeClass('btn--primary');
              $('#warn-na').html('<p class="booking-errors">Helaas is jouw selectie niet meer beschikbaar.</p>').show();

              $('div.optionrequest').hide();
              return;
            } else if (!$('input[type="submit"]').hasClass('btn--primary') && !$('input[type="submit"]').hasClass('btn-checkout') && $('input[required="required"]').val()) {
              console.info('enable submit with class btn--primary');
              $('input[type="submit"]').removeAttr('disabled').addClass('btn--primary');
              $('#warn-na').hide().html('');
            }

            if (xmlHttpResponse.data.availability.toUpperCase().match(/RQ/)) {
              $('div.alert-box.availability > .alert-box-title').html('Je geselecteerde reis is op aanvraag.');
              $('div.alert-box.availability > .alert-box-content').html('Wanneer je nu boekt hoor je zo snel mogelijk (max. 3 dagen) of je mee kunt gaan.');
              $('div.alert-box.availability').show();

              content += Mustache.render(info_line, {
                type: 'warning',
                info: 'Let op: je boeking is op aanvraag. Je hoort zo snel mogelijk (max. 3 dagen) van ons of je mee kan.'
              });

              $('div.optionrequest').hide();
            }


            if (xmlHttpResponse.data.availability.toUpperCase().match(/RQ|NA/)
              || ('is_optionbooking_available' in xmlHttpResponse.data && !xmlHttpResponse.data.is_optionbooking_available)) {
              $('div.optionrequest').hide();
            } else {
              $('div.optionrequest').show();
            }
          }

          var departure = dayjs(xmlHttpResponse.data.trip.departure, 'YYYY-MM-DD');
          var returndate = dayjs(xmlHttpResponse.data.trip.departure, 'YYYY-MM-DD')
            .add(xmlHttpResponse.data.trip.duration - 1, 'day');

          var transport = false;
          var icon = false;
          switch (xmlHttpResponse.data.trip.transport) {
            case 'vl':
            default:
              transport = 'Vliegtuig';
              icon = 'W';
              break;
            case 'bu':
              transport = 'Busreis';
              icon = 'b'
              break;
            case 'ev':
              transport = 'Eigen vervoer';
              icon = 'F';
              break;
            case 'tr':
              transport = 'Treinreis';
              icon = 'b'
              break;
          }

          var receipt_content = Mustache.render(receipt_meta, {
            'departure': departure.format('D MMM'),
            'return': returndate.format('D MMM'),
            'duration': xmlHttpResponse.data.trip.duration,
            'audience': xmlHttpResponse.data.trip.audience.replace(/([0-9]{2})([0-9]{2})/, '$1 - $2 jaar'),
            'transport': transport,
            'transport_icon': icon,
          });


          // content += Mustache.render(receipt_line, {key:'Periode', value: departure.format('D MMM') + ' - ' + returndate.format('D MMM') + ' ('+xmlHttpResponse.data.trip.duration+' dagen)'});
          // content += Mustache.render(receipt_line, {key:'Leeftijdsgroep', value: xmlHttpResponse.data.trip.audience.replace(/([0-9]{2})([0-9]{2})/, '$1 - $2 jaar')});
          // content += Mustache.render(receipt_line, {key:'Vervoer', value: transport});

          // if( xmlHttpResponse.data.trip.transport.toUpperCase() == 'BU' && xmlHttpResponse.data.trip.departureplace ) {
          //     content += Mustache.render(receipt_line, {key:'Opstapplaats', value: xmlHttpResponse.data.trip.departureplace});
          // }

          var boardtype = xmlHttpResponse.data.trip.boardtype;
          // content += Mustache.render(receipt_line, {key:'Verzorging', value: boardtype.charAt(0).toUpperCase() + boardtype.slice(1)});

          var total_amount = 0;
          var component_contents = '';

          var component_partials = ['reissom', 'extras', 'toeslagen', 'verzekeringen', 'kortingen'];
          if (app_request_type && app_request_type == 'option') {
            component_partials = ['reissom'];
          }

          component_partials.forEach(function (el, idx) {
            if (xmlHttpResponse.data.components[el].length > 0) {
              var components_list = [],
                component_total = 0,
                component_title = el;

              xmlHttpResponse.data.components[el].forEach(function (el2, idx2) {

                if (!el2) {
                  return;
                }

                var price = parseFloat(el2.price.price || el2.price);

                if (!price) {
                  price = 0;
                }

                total_amount += price;
                component_total += price;

                components_list.push({
                  'description': el2.description, // .substr(0, 28),
                  'amount': price ? price.toFixed(2).replace('.', ',') : false,
                });

              });


              if (component_title == 'extras') {
                component_title = "extra's";
              }

              component_title = component_title.charAt(0).toUpperCase() + component_title.slice(1)

              component_contents += Mustache.render(receipt_component, {
                'component_title': component_title,
                'components_list': components_list,
                'identifier': el,
                'component_costs': component_total ? component_total.toFixed(2).replace('.', ',') : false,
              });
            }
          });

          receipt_content += '<ul class="component accordion">' + component_contents + '</ul>';

          $('div.receipt-jsrender-components-container').html(receipt_content);
          $('div.receipt-jsrender-total-container').html(Mustache.render(receipt_total, {
            'total_amount': total_amount.toFixed(2).replace('.', ',')
          }));


          content += '</ul>';

          $('#receipt_total').show();

          $('#mobile-total-price').html('&euro; ' + total_amount.toFixed(2).replace('.', ','));

          if (xmlHttpResponse.data.mandatory_costs.length >= 1) {
            var mandatory = '<div id="mandatory_costs" class="block__content mandatory"><ul>';
            var mandatory_lines = '';
            xmlHttpResponse.data.mandatory_costs.forEach(function (el, idx) {
              price = parseFloat(el.price);
              mandatory_lines += Mustache.render(component_line, {
                name: el.description,
                amount: price.toFixed(2).replace('.', ',') + ' ' + el.price_type
              });
            });
            mandatory += Mustache.render(component_block, {
              component_title: 'Lokaal te voldoen',
              component_costs: mandatory_lines,
            });
            mandatory += '</ul></div>';

            $('div.receipt-jsrender-components-container').closest('div.block').append(mandatory);
          }

          if (xmlHttpResponse.data.messages.length >= 1) {
            xmlHttpResponse.data.messages.forEach(function (msg, idx) {
              if (msg.source == 'discount') {
                content = msg.content.charAt(0).toUpperCase() + msg.content.slice(1);
                $('#t_kortingscode_error').addClass(msg.type).html(content);
              }
            });
          }

          $('div.receipt-jsrender-tripinfo-container').html(content);

          $('div.receipt-jsrender-components-container').find('.accordion').on('click', '.accordion-title', function (e) {
            var elem = $(this);
            elem.parent().toggleClass('active');

            if (elem.parent().hasClass('active')) {
              elem.attr('aria-expanded', 'true');
            } else {
              elem.attr('aria-expanded', 'false');
            }
          });
        })
        .then(() => {
          recalculation_running = false;
          if (wants_recalculation) {
            recalculate_and_build_bon();
            wants_recalculation = false;
          }
        });

    } else {
      console.info('calculation is runnning..');
      wants_recalculation = true;
    }
  }

  function check_birthdate_for_group() {
    var MAX_DIFFERENCE = 5,  // 5 years difference allowed as per Nov 2025
      $el = $('input[name="birthdate"]');

    if (!$el.val()) {
      console.info('no value set for birthdate, skipping check for now..');
      return;
    }

    var birthdate = dayjs($el.val(), 'DD-MM-YYYY'),
      departure = dayjs($('input[name="departure"]:checked').val(), 'YYYY-MM-DD'),
      audience = new String($('input[name="departure"]:checked').data('audience')),
      ages = [];


    if (/[0-9]{2}\+/.test(audience)) {
      ages = audience.match(/([0-9]{2}).*/);
      ages[2] = "85";
    } else {
      ages = audience.match(/([0-9]{2})([0-9]{2})/);
    }

    var min_age = parseInt(ages[1], 10) - MAX_DIFFERENCE,
      max_age = parseInt(ages[2], 10) + MAX_DIFFERENCE,
      age = departure.year() - birthdate.year();

    if (departure.month() < birthdate.month()) {
      age--;
    }


    if (age >= min_age && age <= max_age) {
      if ($el.hasClass('error') || $el.hasClass('error--agegroup')) {
        $el.removeClass('error').removeClass('error--agegroup');
        $el.parents('div.input-wrapper').siblings('span.agegroup-error').remove()

        console.info('enable all submits and add class btn-primary')
        $('input[type="submit"]').removeAttr('disabled').addClass('btn--primary');
        $('#warn-na').hide().html('');
        $('#agegroup-error').html('').hide();
      }
      return true;
    }

    if (!$el.hasClass('error')) {

      $el.addClass('error').addClass('error--agegroup');

      var msg = Mustache.render(error_message, {
        'msg': window.error_agegroup
      });

      $el.parents('div.input-wrapper').removeClass('input-wrapper--success').after(msg);
      $('input[type="submit"]').attr('disabled', 'disabled').removeClass('btn--primary');
      $('#warn-na').html(msg).show();
    }

    return false;
  }


  function roomtype_on_change() {

    if (!$('input[name="roomtype"]').length) {
      return;
    }

    let selected = $('input[name="roomtype"]:checked').val().toLowerCase();
    var elms = $('.show-on-roomtype-oi'),
      show = /oi$/.test(selected);

    $('div.roomtype_extras').hide();
    $('div.roomtype_extras_' + selected).show();

    elms.each(function (idx, elm) {
      let $elm = $(elm);
      if ($elm.hasClass('hidden') && show) {
        $elm.removeClass('hidden');
      } else if (!$elm.hasClass('hidden') && !show) {
        $elm.addClass('hidden');
      }
    });
  }


  function toggle_submit_on_insurance() {
    var selected_insurance = $('input[name="insurance"]:checked')

    if (selected_insurance.length <= 0) {
      $('input[type="submit"]').attr('disabled', 'disabled').removeClass('btn--primary');
    }
    else {
      $('input[type="submit"]').removeAttr('disabled').addClass('btn--primary');
    }
  }


  function toggle_submit_on_confirm() {

    var agree_checked = $('#agree').is(':checked') || false,
      paymentmethod_checked = $('input[name="paymentmethod"]').is(':checked') || false,
      booking_nok = $('input[name="paymentmethod"][type="hidden"]').length > 0 || false;

    if (agree_checked && (paymentmethod_checked || booking_nok)) {
      $('#sbmt').removeAttr('disabled').addClass('btn--primary');
    }
    else {
      $('#sbmt').attr('disabled', 'disabled').removeClass('btn--primary');
    }
  }


  function toggle_submit_on_payment() {
    if ($('input[name=issuer]').is(':checked')) {
      $('#sbmt').removeAttr('disabled').addClass('btn--primary');
    }
    else {
      $('#sbmt').attr('disabled', 'disabled').removeClass('btn--primary');
    }
  }


  $(document).ready(function () {
    console.info('hello document ready from checkout!');

    var maxdate = new Date();
    maxdate.setFullYear(maxdate.getFullYear() - 20);

    var receipt_original_offset = false;


    if ($('.date').length >= 1) {
      flatpickr(".date", {
        maxDate: maxdate,
        dateFormat: "d-m-Y",
        allowInput: true,
        "locale": "nl",
      });
    }


    $('.bonfocus').on('click', function (ev) {
      if (window.innerWidth < 1024 || window.screen.width < 1024) {
        console.info('not scrolling into focus');
        return;
      }

      var container = $(ev.target).closest('div.bonfocus'),
        container_offset = container.offset(),
        receipt_container = $('#trip-receipt-container').parent('aside'),
        receipt_offset = receipt_container.offset();

      if (!receipt_original_offset) {
        receipt_original_offset = receipt_offset;
      }

      receipt_container.css('position', 'relative').css('left', 0).css('top', 0);
      receipt_container.css('top', container_offset.top - receipt_original_offset.top);
    });

    $('input[readonly="readonly"]').on('click', function (ev) {
      return false;
    });

    $('input[name="roomtype"]').on('change', roomtype_on_change);

    $('input[name="transport"]').on('change', function (ev) {
      // console.info('transport changed');

      var $ev = $(ev),
        $this = $(this),
        $parent = $this.closest('div.transporttype');

      var original = $parent.data('selected').toLowerCase(),
        selected = $this.val().toLowerCase();

      // console.info('original:', original, 'selected: ', selected);
      // console.info(travel_days_transport);
      // console.info(travel_days_transport_json);

      if (original != selected) {
        $parent.data('selected', selected);

        const travel_days = Number(travel_days_transport_json[selected] ? travel_days_transport_json[selected][0] : 0); // index 0 is departure days, index 1 is return days

        // console.info('travel days: ' + travel_days, typeof travel_days);

        $('input[name="departure"]').each(function (idx, el) {
          var $el = $(el),
            departure = dayjs($el.val(), ['YYYY-MM-DD', 'DD-MM-YYYY']),
            $label = $('label[for="' + $el.attr('id') + '"]');

          // console.info(departure);

          // console.info('departure: ' + departure.format('D MMM YYYY'));

          if (travel_days != 0) {
            departure = departure.subtract(travel_days, 'days');
          }

          // console.info('departure: ' + departure.format('D MMM YYYY'));

          $label.html(departure.format('D MMM YYYY'));
        });

        ['vl', 'bu', 'ev', 'tr'].forEach(function (selector) {
          var t = $('.show-' + selector);
          if (t.length > 0) {
            t.hide();
          }

          var s = $('#' + selector + '-not-default');
          if (s.length > 0) {
            s.hide();
          }

        });

        var t = $('.show-' + selected);
        if (t.length > 0) {
          t.show();
        }
        var s = $('#' + selected + '-not-default');
        if (s.length > 0) {
          s.show();
        }
      }
    });

    $('input[name="samenreis"]').on('change', function (ev) {
      switch ($(this).val()) {
        case "Ja":
          $('input[name="traveltype"]').removeAttr('disabled');
          break;

        case "Nee":
        default:
          $('input[name="traveltype"]').prop('checked', false).attr('disabled', 'disabled');
          break;
      }
    });

    $('input[name="traveltype"]').on('change', function (ev) {
      switch ($(this).val()) {
        case "Carpool":
          $('input[name="travelshare"]').removeAttr('disabled');
          break;

        case "Treinen":
        default:
          $('input[name="travelshare"]').prop('checked', false).attr('disabled', 'disabled');
          break;
      }
    });

    $('input[required]').on('change', function (e) {
      // console.info('check required field');
      var $this = $(this),
        $target = $(e.target),
        pattern = new RegExp($this.attr('pattern'));

      // console.info([pattern.toString(), $this.val(), pattern.test($this.val())]);
      if ($this.val().match(pattern) === null) {
        $this.addClass('error');
      } else {
        $this.removeClass('error');
      }

      if ($target.val() && e.target.validity && e.target.validity.valid) {
        $target.parent('.input-wrapper').removeClass('input-wrapper--error');
        $target.parent('.input-wrapper').addClass('input-wrapper--success');
      }

      if (!$target.val() || (e.target.validity && !e.target.validity.valid)) {
        $target.parent('.input-wrapper').removeClass('input-wrapper--success');
        $target.parent('.input-wrapper').addClass('input-wrapper--error');
      }
    });

    $('input[name="lugage"]').on('change', function (e) {
      var $this = $(this);

      $('input[name="lugage"]').parent().find('p.select-table-item__label:not(.select-table-item__label--top)').html('Kies');

      if ($this.is(':checked')) {
        var $chosen = $this.parent().find('p.select-table-item__label').last();
        $chosen.html('Gekozen');
      }
    });

    $('input[name="trees"]').on('change', function (e) {
      var $this = $(this);

      $('input[name="trees"]').parent().find('p.select-table-item__label:not(.select-table-item__label--top)').html('Kies');

      if ($this.is(':checked')) {
        var $chosen = $this.parent().find('p.select-table-item__label').last();
        $chosen.html('Gekozen');
      }
    });

    $('input[name="birthdate"]').on('change', function (ev) {
      var $this = $(this);
      $this.val(dayjs($this.val(), 'DD-MM-YYYY').format('DD-MM-YYYY'));
      check_birthdate_for_group()
    });

    $('input[name="departure"]').on('change', check_birthdate_for_group);

    $('input[name="departure"]').on('change', (e) => {
      if ($('#btn_option_booking').length >= 1) {
        var href = new URL($('#btn_option_booking').attr('href'), document.location.href);
        href.searchParams.set('departure', $(e.target).val());
        $('#btn_option_booking').attr('href', href.toString());
      }
    });

    if ($('input[name="transport"]:checked').length) {

      console.info('running initial transport check');

      var original = $('input[name="transport"]:checked').val().toLowerCase(),
        selected = $('input[name="transport"]:checked').val().toLowerCase();

      if ($('#vl-not-default').length && $('input[name="transport"]:checked').val().toLowerCase() == 'vl') {
        $('#vl-not-default').show();
      }
      else if ($('#vl-not-default').length) {
        $('#vl-not-default').hide();
      }

      const selected_transport = $('input[name="transport"]:checked').val().toLowerCase() || 'vl';

      ['ev', 'bu', 'vl', 'tr'].forEach((transport) => {
        var $h = $('.show-' + transport);
        if ($h.length > 0) {
          $h.hide();
        }
      });

      $('.show-' + selected_transport).show();
    }



    $('#t_kortingscode').on('change', function (ev) {
      ev.preventDefault();
      // console.info('discount-code changed');
      var $this = $(this);
      if ($this.val() && $this.val().length >= 3) {
        $('button[name="discount-redeem"]').addClass('btn--primary');
        $error = $('#t_kortingscode_error');
        if ($error.hasClass('error')) {
          $error.removeClass('error').html('');
        }
      }
    });

    $('button[name="discount-redeem"]').on('click', function (ev) {
      ev.preventDefault();
      // console.info('discount-redeem clicked');
      var $this = $(this);
      if ($this.hasClass('btn--primary')) {
        // console.info('redeem');
        recalculate_and_build_bon();
      }
    });

    $('input[name="smoking"]').on('change', function (ev) {
      var $this = $(this);
      if ($this.val() != 'x') {
        $('#smoking-notification').show();
      } else {
        $('#smoking-notification').hide();
      }
    });
    $('#smoking-notification').hide();

    // on all .recalculate
    $('.recalculate').on('change', function () {
      window.setTimeout(recalculate_and_build_bon, 100);
    });

    // and after page load..
    recalculate_and_build_bon();
    roomtype_on_change();

    if ($('input[name="insurance"]').length >= 1) {
      $('input[name="insurance"]').on('change', toggle_submit_on_insurance);

      if ($('input[name="insurance"]:checked').length <= 0) {
        $('input[name="insurance"][value="' + cancelation_code + ',' + travelinsurance_code + '"]')
          .attr('checked', 'checked')
          .trigger('change');
      }

      toggle_submit_on_insurance();
    }


    $('input[name="paymentmethod"]').on('change', function (ev) {
      var selected_method = $(ev.target).val();
      var amount_block = $('#payment_amount_choice');
      if (selected_method == 'ideal' && amount_block) {
        amount_block.show();
      }
      else if (amount_block) {
        amount_block.hide();
      }
    });

    if ($('#agree').length >= 1) {
      $('#agree, input[name="paymentmethod').on('change', toggle_submit_on_confirm);
      $('#confirm-booking').on('submit', function () {
        $('#waiting-for-completion').show();
        $('#sbmt').attr('disabled', 'disabled').removeClass('btn--primary');
      });
      $('#waiting-for-completion').hide();
      toggle_submit_on_confirm();
    }

    if ($('input[name=issuer]').length >= 1) {
      $('input[name=issuer]').on('change', toggle_submit_on_payment);
      toggle_submit_on_payment();
    }


  });

})($);
